import { checkBetchuInCart } from './betchu'

export default checkBetchuInCart
